import type { Campaign } from '../campaignsApi';
import { campaignOriginDetails } from '../campaignOriginDetails';
import { CampaignChannelStatuses } from './CampaignChannelStatuses';
import './campaign-origin-details.css';

export function CampaignOriginDetails({ campaign }: { campaign: Campaign }) {
  const missingOrigin = !campaign.meta_campaign_id && !campaign.google_campaign_id;
  return <div className="campaign-origin-details" aria-label="Vínculos da campanha">
    {campaignOriginDetails(campaign).map(origin => <div key={origin.provider}>
      <strong>{origin.provider}</strong><span>{origin.message}</span>
      {origin.accountId && <span>Conta: {origin.accountId}</span>}
      {origin.campaignId && <span>Campanha: {origin.campaignId}</span>}
      {origin.campaignId && !origin.accountId && <span>Conta original não registrada</span>}
    </div>)}
    {missingOrigin && <small>O status exibido é local. A veiculação não está confirmada.</small>}
    {!missingOrigin && <CampaignChannelStatuses campaign={campaign} />}
  </div>;
}
